module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [(_vm.anyMissionSlotSelected) ? _c('th', {
    staticStyle: {
      "width": "1%"
    }
  }) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    style: (_vm.missionSlotRoleStyle)
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.role')))]), _vm._v(" "), _c('th', {
    style: (_vm.missionSlotPlayerStyle)
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.player')))]), _vm._v(" "), (_vm.hasAnyMissionSlotDescription) ? _c('th', {
    staticStyle: {
      "width": "28%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.description')))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.missionSlotGroup.slots), function(missionSlot) {
    return _c('mission-slotlist-group-slots-row', {
      key: missionSlot.uid,
      attrs: {
        "missionSlotDetails": missionSlot,
        "missionSlotGroup": _vm.missionSlotGroup,
        "hasAnyMissionSlotDescription": _vm.hasAnyMissionSlotDescription
      }
    })
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.missionSlotGroup.slots.length >= 10),
      expression: "missionSlotGroup.slots.length >= 10"
    }]
  }, [_c('tr', [(_vm.anyMissionSlotSelected) ? _c('th', {
    staticStyle: {
      "width": "1%"
    }
  }) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "6%"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    style: (_vm.missionSlotRoleStyle)
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.role')))]), _vm._v(" "), _c('th', {
    style: (_vm.missionSlotPlayerStyle)
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.player')))]), _vm._v(" "), (_vm.hasAnyMissionSlotDescription) ? _c('th', {
    staticStyle: {
      "width": "28%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.slot.description')))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f16f7e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/missions/MissionSlotlistGroupSlotsTable.vue
// module id = 546
// module chunks = 0